import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      align: "right"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.form = {
          url: "",
          account: "",
          pwd: "",
          name: "",
          serviceName: "",
          welcomeMsg: "",
          role: []
        };
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v("新增 ")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "头像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-image", {
          attrs: {
            src: scope.row.url,
            width: "60"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "account",
      label: "账号"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "昵称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "serviceName",
      label: "客服昵称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "roleDisplay",
      label: "角色"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm.operable(scope.row.power) ? [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("修 改 ")]), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删 除 ")])] : undefined;
      }
    }], null, true)
  })], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(_vm.$route.meta.title, "\u7F16\u8F91"),
      width: "30%",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      model: _vm.form,
      "label-position": "right",
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "头像"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      url: _vm.form.url
    },
    on: {
      "update:url": function updateUrl($event) {
        return _vm.$set(_vm.form, "url", $event);
      }
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "账号"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.account,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "account", $$v);
      },
      expression: "form.account"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "密码"
    }
  }, [_c("el-input", {
    attrs: {
      type: "password"
    },
    model: {
      value: _vm.form.pwd,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pwd", $$v);
      },
      expression: "form.pwd"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "昵称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "角色"
    }
  }, [_c("el-checkbox-group", {
    on: {
      change: _vm.handleCheckedRole
    },
    model: {
      value: _vm.checkedRole,
      callback: function callback($$v) {
        _vm.checkedRole = $$v;
      },
      expression: "checkedRole"
    }
  }, _vm._l(_vm.roleOptions, function (item) {
    return _c("el-checkbox", {
      key: item.value,
      attrs: {
        label: item.label
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "客服昵称"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.serviceName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "serviceName", $$v);
      },
      expression: "form.serviceName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "欢迎语"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.welcomeMsg,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "welcomeMsg", $$v);
      },
      expression: "form.welcomeMsg"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };